import { render, staticRenderFns } from "./pick-3.vue?vue&type=template&id=ee24e42a"
import script from "./pick-3.vue?vue&type=script&lang=js"
export * from "./pick-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports